import { createGetDownloadPath } from 'src/utils/api/reportUtils';

export const getDownloadPath = createGetDownloadPath(
  '/api/vendors/deals/:deal_id/deal_completion_reports'
);
